import bankingFA from './fa/fa.json'

const BankingMessages = {
  fa: { ...bankingFA },
}

export default BankingMessages
